

import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BirthDayList } from 'src/app/admin/models/birthdaylistmodel';
import { CostumArray } from 'src/app/admin/models/customArray';
import { Playroom } from 'src/app/admin/models/playroom.model';
import { RoomArray } from 'src/app/admin/models/roomArray';
import { SlotsbyDate } from 'src/app/admin/models/SlotsbyDate';
import { Zone } from 'src/app/admin/models/zone.model';
import { ZoneArray } from 'src/app/admin/models/zoneArray';
import { BirthdayListService } from 'src/app/admin/services/birthday-list.service';
import { CommonMethodesService } from 'src/app/admin/services/common-methodes.service';
import { PlayroomService } from 'src/app/admin/services/playroom.service';
import { RodjendanskezoneService } from 'src/app/admin/services/rodjendanskezone.service';
import { User } from 'src/app/models/user.model';
import { VisitorService } from '../../../services/visitor.service';
import { validateBirthDayList } from 'src/app/utils/formValidators';


@Component({
  selector: 'app-edit-birthday',
  templateUrl: './edit-birthday.component.html',
  styleUrls: ['./edit-birthday.component.scss'],
})
export class EditBirthdayComponent implements OnInit {

  userList: Array<CostumArray>;

  @Input() birthdayListList!: BirthDayList;

  selectedUser: CostumArray | null = null
  playroom: Playroom[]
  roomList: Array<RoomArray>;
  selectedRoom: RoomArray | null = null

  zoneList: Array<ZoneArray>
  selectedZone: ZoneArray | null = null
  zone: Zone[]
  users: User[];
  currentPage: number = 1;
  itemsPerPage: number = 10;
  itemsPerPageLarge: number = 2147483647;
  callDateInput: string = ""
  appointmentDateInput: string = ''
  errMsg = '';

  cityQuery: string = ''
  roomNameQuery: string = '';
  birthdayZoneNameQuery: string = '';
  VisitorNameQuery: string = ''; 
  CallDateFromQuery: string = '';
  CallDateToQuery: string = '';
  AppointmentDateFromQuery: string = '';
  AppointmentDateToQuery: string = ''; 
  PricePerChildrenFromQuery:string=''
  PricePerChildrenToQuery: string=''
  PlannedChildNumberFromQuery: string = '';
  PlannedChildNumberToQuery: string = '';
  PresentChildNumberQuery: string = '';
  PresentChildNumberFromQuery: string = '';
  PresentChildNumberToQuery: string = '';
  TotalPricePaidQuery: string = '';
  TotalPricePaidFromQuery: string = '';
  TotalPricePaidToQuery: string = '';
  StatusCallQuery: string = '';
  availibleslots: SlotsbyDate[] = []
  fromDate: Date | null = null
  toDate: Date | null = null
  initialLoad: boolean = false
  inititialBitrthayStart: string = ''
  NumberOfBirthdayFromQuery: string = ''
  NumberOfBirthdayToQuery: string = ''
  AdvancePaymentWillQuery:string=''
  AdvancePricePaidFromQuery:string=''
  AdvancePricePaidToQuery:string=''

  birthdayAdds: { name: string; price: number }[] = [
    { name: '', price: 0 }
  ];
  birthDayAdssPriceTotal: number = null

   messageError: string = ''
   errMsgInputDate: string = ''
  errMsgInputTime:string=""
  constructor(private modalController: ModalController, private roomService: PlayroomService,
    private commonMethodsService: CommonMethodesService, private birthdayListService: BirthdayListService,
    private rodjendanskezoneservice: RodjendanskezoneService, private visitorService: VisitorService) { }

  async ngOnInit() {


    this.roomService.getAllPlayroomsSub().subscribe(async data => {
      this.playroom = data;
      this.userList = this.commonMethodsService.mapPlayroomsToUserList(this.playroom);
console.log(" this.userList" , this.userList)
      this.selectedUser = this.userList.find(x => x.display === this.birthdayListList.city);

      this.roomList = this.commonMethodsService.mapPlayroomsToRoomList(this.playroom, this.birthdayListList.city);
console.log("this.playroom" ,this.playroom)
      this.selectedRoom = this.roomList.find(x => x.display === this.birthdayListList.roomName);


      this.rodjendanskezoneservice.getAllPlayroomZonesSub({ currentPage: this.currentPage, itemsPerPage: this.itemsPerPageLarge }).subscribe(async data => {
        this.zone = data;
        var disp = this.roomList;
        this.zoneList = this.commonMethodsService.mapPlayroomsToZoneList(this.zone, this.birthdayListList.roomName);

        this.selectedZone = this.zoneList.find(
          x => x.display === this.birthdayListList.birthdayZoneName
        );

        this.birthdayListList.BirthdayZoneId = parseInt(this.selectedZone.value)
        this.birthdayListList.callDateInput = this.formatDateForInput(this.birthdayListList.callDate);
        this.birthdayListList.appointmentDateInput = this.formatDateForInput(this.birthdayListList.appointmentDate);
        this.formatApoitmentFrom()
        this.formatApoitmentTo()
        await this.getSlots(this.fromDate, this.toDate)

       
       
       
        this.birthdayListList.startTimeBirthday = this.formatTimeForInput
          (
            this.convertLocalDateToLocalString(
              this.parseUtcToLocal(this.birthdayListList.birthdayStart)
            )
          )

        this.birthdayListList.inititialBitrthayStart = this.formatTimeForInput
          (
            this.convertLocalDateToLocalString(
              this.parseUtcToLocal(this.birthdayListList.birthdayStart)
            )
          )


           this.birthdayListList.endTimeBirthday = this.formatTimeForInput
          (
            this.convertLocalDateToLocalString(
              this.parseUtcToLocal(this.birthdayListList.birthDayEnds)
            )
          )


      
          console.log('vlada Ngonit this.birthdayListList.startTimeBirthday', this.birthdayListList.startTimeBirthday)
        console.log('vlada Ngonit this.birthdayListList', this.birthdayListList)
      })
    });
    this.initialLoad = true
    this.birthdayListList.inititialBitrthayStart = this.birthdayListList.startTimeBirthday
 
  console.log('vlada Ngonit this.birthdayListList NGFINAL', this.birthdayListList)
  }

  convertLocalDateToLocalString(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }


  formatTimeForInput(dateString: string): string {
    const date = new Date(dateString);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  }


  onUserChange(event: any) {
    this.getReducedArray()
    this.zoneList = []
   
    this.birthdayListList.roomId = null
    this.birthdayListList.BirthdayZoneId = null;

    this.roomList = this.commonMethodsService.mapPlayroomsToRoomList(this.playroom, this.selectedUser.display);

    this.selectedRoom = this.roomList.find(x => x.display === this.birthdayListList.roomName);


  }


  getReducedArray() {
    this.roomList = []

    var disp = this.selectedUser?.display

    this.roomList = this.commonMethodsService.mapPlayroomsToRoomList(this.playroom, disp);

  }
  onRoomChange(event: any) {
    this.birthdayListList.BirthdayZoneId = null
    this.zoneList = []
    this.getReducedZoneArray()

    this.commonMethodsService.getEmployeesByRoom(
      parseInt(this.selectedRoom.value),
      this.currentPage,
      this.itemsPerPage
    ).subscribe(employees => {
      console.log("EMP", employees);
      if (employees.length > 0) {
        this.birthdayListList.EmployeeId = employees[0].id;
        this.birthdayListList.EmployName = employees[0].username;
      }

    });

    this.birthdayListList.roomId = parseInt(this.selectedRoom.value)


  }
  compareWithFn = (o1: ZoneArray, o2: ZoneArray) => {
    return o1 && o2 ? o1.value === o2.value : o1 === o2;
  };

  getReducedZoneArray() {

    this.rodjendanskezoneservice.getAllPlayroomZonesSub({ currentPage: this.currentPage, itemsPerPage: this.itemsPerPage }).subscribe(data => {
      this.zone = data;
      var disp = this.selectedRoom.display;
      this.zoneList = this.commonMethodsService.mapPlayroomsToZoneList(this.zone, disp);

      if (this.zoneList.length > 0) {

        const prev = this.selectedZone ? this.zoneList.find(z => z.value === this.selectedZone.value) : null;

      }

    })

  }  
    async onZoneChange(event: any) {
    this.birthdayListList.BirthdayZoneId = parseInt(this.selectedZone.value)
    console.log('NgOnit appoitment', this.birthdayListList.appointmentDateInput)
    this.formatApoitmentFrom()
    this.formatApoitmentTo()
    console.log("this.fromDateAPPDate", this.fromDate)
    console.log("this.toDateAPPDate", this.toDate)




    await this.getSlots(this.fromDate, this.toDate)
    console.log("APPOITMENT Changed Slots", this.availibleslots)
    this.birthdayListList.appointmentDate = this.formatDateForISO(this.birthdayListList.appointmentDateInput)
   if(this.birthdayListList.SaveTimeEndSlotId===null){
    this.onStartTimeChanged()

   }
   else{
    this.onStartTimeChangedFlex()
   }
    

  
  }


  formatDateForInput(date: Date | string): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  formatTimeForInputStart(date: Date | string): string {
    const d = new Date(date);

    const hour = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0')

    console.log('RETURN', `${hour}:${minutes}`)
    return `${hour}:${minutes}`;
  }

  formatTimeForInputEnd(date: Date | string): string {


    const d = new Date(date);
    console.log("tIME END DATE d", d)
    const hour = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0')

    console.log('RETURN', `${hour}:${minutes}`)
    return `${hour}:${minutes}`;
  }
 



  getAllBirthdayRefresh() {
    this.birthdayListService.getAllBirthday({
      currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
      VisitorIdQuery: this.birthdayListList?.VisitorId ?? null,
      cityQuery: this.cityQuery,
      roomNameQuery: this.roomNameQuery,
      birthdayZoneNameQuery: this.birthdayZoneNameQuery,
      VisitorNameQuery: '',     
      CallDateFromQuery: this.CallDateFromQuery,
      CallDateToQuery: this.CallDateToQuery,
      AppointmentDateFromQuery: this.AppointmentDateFromQuery,
      AppointmentDateToQuery: this.AppointmentDateToQuery,
       PricePerChildrenFromQuery:this. PricePerChildrenFromQuery,   
       PricePerChildrenToQuery: this.PricePerChildrenToQuery,    
      PlannedChildNumberFromQuery: this.PlannedChildNumberFromQuery,
      PlannedChildNumberToQuery: this.PlannedChildNumberToQuery,
      PresentChildNumberFromQuery: this.PresentChildNumberFromQuery,
      PresentChildNumberToQuery: this.PresentChildNumberToQuery,
      TotalPricePaidFromQuery: this.TotalPricePaidFromQuery,
      TotalPricePaidToQuery: this.TotalPricePaidToQuery,
      StatusCallQuery: this.StatusCallQuery="0",
      NumberOfBirthdayFromQuery: this.NumberOfBirthdayFromQuery,
      NumberOfBirthdayToQuery: this.NumberOfBirthdayToQuery,
      AdvancePaymentWillQuery:this.AdvancePaymentWillQuery,
      AdvancePricePaidFromQuery:this.AdvancePricePaidFromQuery,
      AdvancePricePaidToQuery:this.AdvancePricePaidToQuery
    })
  }


  dismissModal() {
    this.getAllBirthdayRefresh()
    this.modalController.dismiss();
  }

  formatApoitmentFrom() {

    const appointmentDate = new Date(this.birthdayListList.appointmentDateInput);
    const fromDate = new Date(Date.UTC(
      appointmentDate.getFullYear(),
      appointmentDate.getMonth(),
      appointmentDate.getDate(),
      0, 0, 0
    ));
    this.fromDate = fromDate
  }

  formatApoitmentTo() {
    const appointmentDate = new Date(this.birthdayListList.appointmentDateInput);
    const toDate = new Date(Date.UTC(
      appointmentDate.getFullYear(),
      appointmentDate.getMonth(),
      appointmentDate.getDate() + 1,
      0, 0, 0
    ));
    this.toDate = toDate
  }

  private fromUtcToLocalTime(utcTimeStr: string, dateContext: string): string {
    // Kombinuje datum konteksta sa UTC vremenom i konvertuje u lokalno vreme
    const dateOnly = dateContext.split('T')[0];
    const fullUtcStr = `${dateOnly}T${utcTimeStr}${utcTimeStr.includes('Z') ? '' : 'Z'}`;
    const localDate = new Date(fullUtcStr);
    const hours = String(localDate.getHours()).padStart(2, '0');
    const minutes = String(localDate.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  async getSlots(fromDate: Date, toDate: Date): Promise<any[]> {
    try {
      const slots = await this.visitorService.getSavedTimeSlots(
        this.birthdayListList.roomId,
        this.birthdayListList.BirthdayZoneId,
        fromDate,
        toDate
      ).toPromise();

      // Konvertuj UTC slotove u lokalno vreme
      this.availibleslots = slots.map(slot => ({
        ...slot,
        start: this.fromUtcToLocalTime(slot.start, this.birthdayListList.appointmentDateInput),
        end: this.fromUtcToLocalTime(slot.end, this.birthdayListList.appointmentDateInput)
      }));

      console.log('Slotovi stigli:', this.availibleslots);
      return this.availibleslots;
    } catch (err) {
      console.error('Greška u getSlots:', err);
      return [];
    }
  }
  compareTimes = (o1: any, o2: any): boolean => {
    return o1 && o2 ? o1.toString() === o2.toString() : o1 === o2;
  };
 
  async  onAppoitmentDateChanged() {
  
    console.log('NgOnit appoitment', this.birthdayListList.appointmentDateInput)
    this.formatApoitmentFrom()
    this.formatApoitmentTo()
    console.log("this.fromDateAPPDate", this.fromDate)
    console.log("this.toDateAPPDate", this.toDate)

    await this.getSlots(this.fromDate, this.toDate)
    console.log("APPOITMENT Changed Slots", this.availibleslots)
    this.birthdayListList.appointmentDate = this.formatDateForISO(this.birthdayListList.appointmentDateInput)

    console.log(' this.birthdayListList.AppointmentDate', this.birthdayListList.appointmentDate)


    this.onStartTimeChanged()

  }

  formatInputTime() {
  }

  onStartTimeChanged() {
    console.log('NgOnit On startTIMECHange', this.birthdayListList.appointmentDateInput, this.birthdayListList.startTimeBirthday)
    if (this.birthdayListList.appointmentDateInput && this.birthdayListList.startTimeBirthday) {
      console.log(' this.birthdaylistlist.startTimeBirthday', this.birthdayListList.startTimeBirthday)

      const [hours, minutes] = this.birthdayListList.startTimeBirthday.split(':').map(Number);

      const date = new Date(this.birthdayListList.appointmentDateInput);
      date.setHours(hours, minutes, 0, 0);

      this.birthdayListList.BirthDayStartDt = date;

      this.birthdayListList.BirthDayStart = new Date(
        this.birthdayListList.BirthDayStartDt
      ).toISOString();

      for (let i = 0; i < this.availibleslots.length; i++) {

        if (this.availibleslots[i].start === this.birthdayListList.startTimeBirthday) {

          if (this.initialLoad == false) {
            this.visitorService.getSavedTimeSlotById(this.availibleslots[i].id).subscribe({
              next: (data) => {

                console.log('Slot data:', data);
              },
              error: (error) => {
                if (error.status === 400) {
                  if (this.birthdayListList.startTimeBirthday != this.birthdayListList.inititialBitrthayStart) {
                    alert('Termin je zauzet!');
                  }
                  this.birthdayListList.startTimeBirthday = this.birthdayListList.inititialBitrthayStart

                } else {
                  console.error('Neočekivana greška:', error);
                }
              }
            });
          }

          this.birthdayListList.endTimeBirthday = this.availibleslots[i].end

          const [hours, minutes] = this.birthdayListList.endTimeBirthday.split(':').map(Number);

          const date = new Date(this.birthdayListList.appointmentDateInput);
          date.setHours(hours, minutes, 0, 0);


          this.birthdayListList.BirthDayEndsDt = date;

          this.birthdayListList.BirthDayEnds = new Date(
            this.birthdayListList.BirthDayEndsDt
          ).toISOString();


          this.birthdayListList.SavedTimeSlotId = this.availibleslots[i].id
          break;
       
        }

      }
    }


    this.initialLoad = false
  }  

 parseUtcToLocal(dateString: string): Date {

    const [datePart, timePart] = dateString.split('T');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);
    return new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds || 0));
  }

 formatDateForISO(dateString: string): string {
    if (!dateString) return dateString;

    if (dateString.includes('T')) return dateString;

    return `${dateString}T00:00:00`;
  }


  addInputField() {

    this.birthdayListList.addsTotalNamePrices.push({ name: '', price: 0 });

  }

 removeInputField(index: number) {
    console.log("index remove", index)
    console.log("this.birthdayListList.addsTotalNamePrices.length", this.birthdayListList.addsTotalNamePrices.length)
    console.log("this.birthDayAdssPriceTotal", this. birthdayListList.totalPricePaidAdds)

    if (this.birthdayAdds.length === 1 && index === 0 && this.birthDayAdssPriceTotal === 0) {

      return
    }

    else if (this.birthdayListList.addsTotalNamePrices.length === 1 && index === 0 && this. birthdayListList.totalPricePaidAdds > 0) {
      this.birthdayListList.addsTotalNamePrices.splice(index, 1);
      this.addInputField()
      this.recalculateTotal()

    }
 
    else if (index === 0 && this.birthdayListList.addsTotalNamePrices.length > 1 && this. birthdayListList.totalPricePaidAdds > 0) {
     this.birthdayListList.addsTotalNamePrices.splice(index, 1);
      this.recalculateTotal()

    }


    else if (index > 0 && this.birthdayListList.addsTotalNamePrices.length > 1 && this. birthdayListList.totalPricePaidAdds > 0) {
      this.birthdayListList.addsTotalNamePrices.splice(index, 1);
      this.recalculateTotal()

    }


 }

  onAddsPriceChange(event: any) {
    this.recalculateTotal()
  }
  private recalculateTotal() {
    this.birthDayAdssPriceTotal = 0
    for (let j = 0; j < this.birthdayListList.addsTotalNamePrices.length; j++) {
      this.birthDayAdssPriceTotal += this.birthdayListList.addsTotalNamePrices[j].price;
    }


    this.birthdayListList.totalPricePaidWithAdds = 0
    this.birthdayListList.totalPricePaidWithAdds = this.birthdayListList.totalPricePaid + this.birthDayAdssPriceTotal


    this.birthdayListList.totalPricePaidAdds = this.birthDayAdssPriceTotal
  }

   
onStartTimeChangedFlex() {
    this.birthdayListList.SavedTimeSlotId = null
   
   console.log('this.birthdayListList.AppointmentDate----onStartTimeChangedFlex()', this.birthdayListList.appointmentDate)
    console.log(' this.birthdayAdd.startTimeBirthday----onStartTimeChangedFlex()', this.birthdayListList.startTimeBirthday)
   
    if (this.birthdayListList.AppointmentDate && this.birthdayListList.startTimeBirthday) {
      console.log(' this.birthdayAdd.startTimeBirthday', this.birthdayListList.startTimeBirthday)
      this.errMsgInputTime = '';


      const [hours, minutes] = this.birthdayListList.startTimeBirthday.split(':').map(Number);

      const date = new Date(this.birthdayListList.AppointmentDate);
      date.setHours(hours, minutes, 0, 0);

      this.birthdayListList.BirthDayStartDt = date;

      this.birthdayListList.BirthDayStart = new Date(
        this.birthdayListList.BirthDayStartDt
      ).toISOString();

      for (let i = 0; i < this.availibleslots.length; i++) {

        if (this.availibleslots[i].start === this.birthdayListList.startTimeBirthday) {

          this.birthdayListList.SavedTimeSlotId = this.availibleslots[i].id
          break;

        }
      }
    }
  }

 onEndTimeChangedFlex() {

console.log('this.birthdayListList.AppointmentDate- onEndTimeChangedFlex() ', this.birthdayListList.appointmentDate)
console.log('this.birthdayListList.endTimeBirthday- onEndTimeChangedFlex() ', this.birthdayListList.endTimeBirthday)


    if (this.birthdayListList.appointmentDate && this.birthdayListList.endTimeBirthday) {
      console.log('this.birthdayAdd.ENDTimeBirthday', this.birthdayListList.endTimeBirthday)
      this.errMsgInputTime = '';
      const [hours, minutes] = this.birthdayListList.endTimeBirthday.split(':').map(Number);

      const date = new Date(this.birthdayListList.AppointmentDate);
      date.setHours(hours, minutes, 0, 0);

      this.birthdayListList.BirthDayEndsDt = date;

      this.birthdayListList.BirthDayEnds = new Date(
        this.birthdayListList.BirthDayEndsDt
      ).toISOString();

      for (let i = 0; i < this.availibleslots.length; i++) {

        console.log("STARTSLOT U END SLOT METODI", this.birthdayListList.SavedTimeSlotId)
        if (this.birthdayListList.SavedTimeSlotId === null) {

          this.birthdayListList.SavedTimeSlotId = -1
        }


        if (this.availibleslots[i].start === this.birthdayListList.endTimeBirthday) {
          this.birthdayListList.SavedTimeEndSlotId = this.availibleslots[i].id
          console.log("ENDSLOT U END SLOT METODI", this.birthdayListList.SavedTimeEndSlotId)

          this.visitorService.getSavedTimeSlotByIdStartEnd(this.birthdayListList.SavedTimeSlotId, this.birthdayListList.SavedTimeEndSlotId).subscribe({
            next: (data) => {

              console.log('Slot data:', data);
            },
            error: (error) => {

              if (error.error.errors.includes('Slots cant be null')) {
                this.messageError = 'Morate uneti vremena početka i završetka rodjendana.';
                alert('Morate uneti vremena početka i završetka rodjendana!');
                this.birthdayListList.endTimeBirthday = ''
                this.birthdayListList.startTimeBirthday = null
                this.birthdayListList.SavedTimeSlotId = null
                this.birthdayListList.SavedTimeSEndlotId = null

              }
              else if (error.error.errors.includes('Birthday-appoitment - is- allredy-booked')) {
                this.messageError = 'Termin je zauzet.';
                alert('Termin je zauzet!');
                this.birthdayListList.endTimeBirthday = ''
                this.birthdayListList.startTimeBirthday = null
                this.birthdayListList.SavedTimeSlotId = null
                this.birthdayListList.SavedTimeSEndlotId = null
              }
              else if (error.error.errors.includes('EndTime - and- StartTime cant be same')) {
                this.messageError = 'Vreme završetka rođendana mora biti veće od vremena početka rođendana.';
                alert('Vreme završetka rođendana mora biti veće od vremena početka rođendana!');
                this.birthdayListList.endTimeBirthday = ''
                this.birthdayListList.startTimeBirthday = null
                this.birthdayListList.SavedTimeSlotId = null
                this.birthdayListList.SavedTimeSEndlotId = null

              }

              else {
                console.error('Neočekivana greška:', error);
              }
              this.errMsgInputTime = this.messageError



            }
          });
          this.birthdayListList.SavedTimeSEndlotId = this.availibleslots[i].id
          break;
        }
      }
    }
  }

}




